import { getEnvironment, ENVIRONMENT } from '../../utils/environment';

const DEV_GRAPHQL_PATH =
  '/gateway/api/graphql?serviceOverride=upp_service_api=https://upp-service-api.ap-southeast-2.dev.atl-paas.net/api/graphql';
const DEFAULT_GRAPHQL_PATH = '/gateway/api/graphql';

const getGraphqlPath = (): string => {
  const env = getEnvironment();
  return env === ENVIRONMENT.DEV ? DEV_GRAPHQL_PATH : DEFAULT_GRAPHQL_PATH;
};

const getUnifiedProfileQuery = (aaid: string) => `
  query UNIFIED_PROFILE_QUERY {
    unified {
      unifiedProfile(aaid: "${aaid}") {
        ... on UnifiedProfile {
          internalId
        }
        ... on UnifiedQueryError {
          code
          identifier
          message
        }
      }
    }
  }
`;

export const getProfileInternalId = async (
  aaid: string,
  baseUrl: string = '',
  Origin?: string,
): Promise<string | null> => {
  try {
    const rawResponse = await fetch(`${baseUrl}${getGraphqlPath()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(Origin ? { Origin } : {}),
      },
      body: JSON.stringify({
        query: getUnifiedProfileQuery(aaid),
        operationName: 'UNIFIED_PROFILE_QUERY',
      }),
    });

    const json = await rawResponse.json();
    const profile = json?.data?.unified?.unifiedProfile;

    if (!profile || 'code' in profile || !profile.internalId) return null;

    return profile.internalId;
  } catch {
    return null;
  }
};
